import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { mockSites, mockState } from '../lib/mocks';
import { Sites } from '../lib/types';
import { blueIcon, blackIcon, greenIcon } from './Icons/Icons';

export const MapComponent = () => {
    const [sites, setSites] = useState<string[]>([]);
    const [state, setState] = useState<Sites>({});
    const [loading, setLoading] = useState<boolean>(true);

    const determineColor = (status: string) => {
        switch (status) {
            case "idle":
                return blueIcon;
            case "contacted":
                return greenIcon;
            default:
                return blackIcon;
        }
    }

    const sitesDisplay = () => sites.map((site) => {
        if(!state[site]) return
        return <Marker icon={determineColor(state[site]?.status)} position={state[site]?.latlon}>
            <Popup>
                {state[site]?.message}
            </Popup>
        </Marker>
    });

    const fetchData = async () => {
        await Promise.all([
            fetch('https://rubeserver.cloud24x7.net/state').then(response => response.json()).then(response => setState(response)),
            fetch('https://rubeserver.cloud24x7.net/sites').then(response => response.json()).then(response => setSites(response)),
        ]).finally(() => setLoading(false));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            fetchData();
        }, 500);
        return () => clearInterval(interval);
    }, []);

    return (
        <MapContainer className="map" center={[20, 10]} zoom={2.25} scrollWheelZoom={false}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {loading ?
                <div>Loading!</div>
            : sitesDisplay()
            }
        </MapContainer>
    );
}
